<template> 
    <div class="media">
        <!-- Banner -->
        <Banner name="banner_media" />

        <div class="num">
            <div class="num-bg">
                <div class="num-card">
                    <div v-for="(item, index) in numList" :key="index" class="item">
                        <div class="number">{{ item.number }}</div>
                        <div class="title">{{ item.title }}</div>
                        <div class="line" v-if="index != numList.length - 1"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="asset">
         <div class="asset-bg">
                <div class="media-title">{{ assetData.title }}</div>
                <div class="media-summary">{{ assetData.summary }}</div>
                <div class="asset-content">
                    <div class="asset-item" v-for="(item, index) in assetData.list" :key="index">
                        <img :src="item.image_url" class="img" />
                        <div class="item">
                            <div class="item-title">{{ item.title }}</div>
                            <div class="item-type">{{ item.summary }}</div>
                            <img src="@assets/media/icon_down.png" srcset="@assets/media/icon_down@2x.png 2x" @click="downLoad(item)" class="item-btn"/>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="submit">
            <div class="media-title">{{ lang.formTitle }}</div>
            <div class="media-summary">{{ lang.formSummary }}</div>
            <div class="submit-form">
                <div class="form-item-title">
                    <img src="@assets/media/icon_hand.png" srcset="@assets/media/icon_hand@2x.png 2x" class="hand-icon" />
                    {{ lang.formSubTitle }}
                </div>
                <div class="form-item-summary">
                    {{ lang.formSubSummary }}
                </div>
                <div class="form-item-merge">
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formMediaName }}</div>
                        <input class="form-item__input" type="text" v-model="form.media_name":placeholder="lang.placeholder">
                    </div>
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formPosition }}</div>
                        <input class="form-item__input" type="text" v-model="form.position" :placeholder="lang.placeholder">
                    </div>
                </div>
                <div class="form-item-merge">
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formContactName }}</div>
                        <input class="form-item__input" type="text" v-model="form.contact_name" :placeholder="lang.placeholder">
                    </div>
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formPhone }}</div>
                        <input class="form-item__input" type="text" v-model="form.phone" :placeholder="lang.placeholder">
                    </div>
                </div>
                <div class="form-item-merge">
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formEmail }}</div>
                        <input class="form-item__input" type="text" v-model="form.email" :placeholder="lang.placeholder">
                    </div>
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formIdCard }}</div>
                        <input class="form-item__input" type="text" v-model="form.id_card" :placeholder="lang.placeholder">
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-item__title"><span class="isRed">*</span>{{ lang.formAddress }}<span class="tips">{{ lang.formAddressDes }}</span></div>
                    <input class="form-item__input" type="text" v-model="form.address" :placeholder="lang.placeholder">
                </div>
                <div class="form-item">
                    <div class="form-item__title"><span class="isRed">*</span>{{ lang.formMediaType }}</div>
                    <div class="form-item__input form-item__type" @click="mediaTypeShow = !mediaTypeShow"> 
                        {{ form.media_type ?? lang.pleaseSelect }}
                        <img src="@assets/media/icon_select.png" srcset="@assets/media/icon_select@2x.png 2x" :class="mediaTypeShow ? 'show-type' : ''" />
                    </div>
                    <div class="form-item__select" v-if="mediaTypeShow">
                        <div class="form-item__select-item" v-for="(item, index) in mediaType" :key="index">
                            <div class="item" 
                                @click="form.media_type = item; mediaTypeShow = false" 
                                :class="form.media_type == item ? 'form-item__select-active' : ''">
                                    {{ item }}
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="submit-btn" @click="submit()">{{ lang.submitBtn }}</div>

                <img src="@assets/media/icon_video.png" srcset="@assets/media/icon_video@2x.png 2x" class="video-icon" />

            </div>
        </div>

    </div> 
</template>

<script setup>
    import Banner from '@/components/banner/index.vue'
    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI, MediaSubmitAPI } from '@/api/common.js';

    // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.media
        mediaType.value = lang.value.mediaType
    }) 

    // 卡片数据参数 
    const numParam = ref({ name: "media_number" })

    // 卡片数据
    const numList = ref([])

    // 卡片数据获取
    const getNum = () => {
        ConfigGetAPI(numParam.value).then(res => {
            numList.value = res.list
        });
    }


    // 资料包
    const assetParam = ref({ name : 'media_asset'})

    // 资料包数据
    const assetData = ref({})

    // 资料包获取
    const getAssetList = () => {
        ConfigGetAPI(assetParam.value).then(res => {
            assetData.value = res
        });
    }

    // 下载资料包
    const downLoad = (item) => {
        // 创建一个 <a> 标签
        const link = document.createElement('a');
        link.href = item.link_url; // 文件的URL
        link.download = item.title; // 设置下载的文件名
        document.body.appendChild(link);
        link.click(); // 触发点击事件
        document.body.removeChild(link); // 下载完成后移除 <a> 标签
    }

    // 参展商参数
    const exhibitorParam = ref({ name : "exhibitor_center" })

    // 参展商数据
    const exhibitorData = ref({ list:[] })

    // 参展商获取
    const getExhibitorData = () => {
        ConfigGetAPI(exhibitorParam.value).then(res => {
            exhibitorData.value = res
        });
    }

    // 媒体类型
    const mediaType = ref([])
    const mediaTypeShow = ref(false)
    
    // 媒体合作表单
    const form = ref({
        media_name: "",
        media_type: null,
        contact_name: "",
        phone: "",
        email: "",
        position: "",
        id_card: "",
        address: "",
        remark: ""
    })
    
    // 媒体合作提交
    const submit = () => {
        validateField(() => {
            MediaSubmitAPI(form.value).then(() => {
                window.alert(lang.value.successSummary)
                form.value = {
                        media_name: "",
                        media_type: null,
                        contact_name: "",
                        phone: "",
                        email: "",
                        position: "",
                        id_card: "",
                        address: "",
                        remark: ""
                    }
            });
        })
    }
    // 媒体合作提交 字段校验
	const validateField = (callback) => {
		let msg = ''
		if (!form.value.media_name) msg = lang.value.tipsMediaName
        else if (!form.value.position) msg = lang.value.tipsPosition
        else if (!form.value.contact_name) msg = lang.value.tipsContactName
        else if (!form.value.phone) msg = lang.value.tipsPhone
        else if (!form.value.email) msg = lang.value.tipsEmail
        else if (form.value.email) {
            const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailReg.test(form.value.email)) msg = lang.value.tipsEmailError
        } 
        else if (!form.value.id_card) msg = lang.value.tipsIdCard
        else if (!form.value.address) msg = lang.value.tipsAddress
        else if (!form.value.media_type) msg = lang.value.tipsMediaType

		msg ? window.alert(msg) : callback?.()
	}


    onMounted(() => {
        getNum()
        getAssetList()
        getExhibitorData();
    });

</script>

<style lang="scss" scoped>

.media {
    .flex {
        display: flex;
    }

    &-title {
        font-family: PingFangSC-medium;
        color: #333333;
        font-weight: 500;
        font-size: 36px;
        letter-spacing: 3px;
        line-height: 56px;  
        margin-bottom: 16px;  
    }

    &-summary {
        color: #666666;
        font-weight: 400;
        font-size: 24px;
        letter-spacing: 2px;
        line-height: 40px;

    }
    
    .num {
        background-color: #F8FAFC;
        padding: 80px 0;
        
        &-bg {
            width: 960px;
            margin: 0 auto;
        }

        &-card {
            width: 960px;
            height: 202px;
            border-radius: 30px;
            background-color: rgba(255, 255, 255, 0.5);
            box-shadow: 0px 10px 18px 0px rgba(40, 44, 108, 0.09);
            display: flex;
            align-content: center;

            .item {
                width: 25%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                text-align: center;
                position: relative;

                .number {
                    font-family: D-DINExp-Bold;
                    color: #333333;
                    font-weight: 700;
                    font-size: 60px;
                    letter-spacing: 5px;
                    line-height: 65px;
                }

                .title {
                    color: #333333;
                    font-weight: 400;
                    font-size: 26px;
                    letter-spacing: 2px;
                    margin-top: 18px;
                    width: 90%;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .line {
                    position: absolute;
                    right: 0;
                    width: 1px;
                    height: 88px;
                    background-color: #E6E6E6;
                    top: 55px;
                }
            }
        }
    }

    .asset {
        background-color: #F8FAFC;
        padding-bottom: 80px;
        
        &-bg {
            width: 1200px;
            margin: 0 auto;
        }

        &-content {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
            margin-top: 36px;
        }

        &-item { 
            width: 282px;
            // height: 259px;
            border-radius: 30px;
            background-color: #FFFFFF;
            box-shadow: 0px 2px 18px 0px rgba(67, 67, 67, 0.18);

            .img {
                width: 282px;
                height: 156px;
                border-radius: 30px 30px 0px 0px;

            }

            .item {
                margin: 10px 24px 20px 24px;
                position: relative;

                &-title {
                    font-family: PingFangSC-medium;
                    color: #333333;
                    font-weight: 500;
                    font-size: 18px;
                    letter-spacing: 2px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    height: 25px;
                    line-height: 25px;
                    margin-bottom: 10px;
                    max-width: 230px;
                }

                &-type {
                    font-family: D-DINExp;
                    color: #666666;
                    font-weight: 400;
                    font-size: 16px;
                    letter-spacing: 2px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    max-width: 80%;
                }

                &-btn {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    cursor: pointer;
                }

                &-btn:hover {
                    opacity: .75;
                }
            }
        }
    }

    .submit {
        width: 1200px;
        margin: 100px auto 80px auto;

        &-form {
            background: linear-gradient(134.26deg, rgba(248, 254, 250, 0.6) 0%, rgba(255, 255, 255, 0.39) 100%),#FFFFFF;
            box-shadow: 0px 10px 18px 0px rgba(40, 44, 108, 0.09);
            margin-top: 24px;
            padding: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 30px;
            position: relative;

            .form-item-title {
                text-align: left;
                width: 100%;
                font-family: PingFangSC-medium;
                color: #333333;
                font-weight: 500;
                font-size: 28px;
                letter-spacing: 2px;
                line-height: 40px;
                display: flex;
                align-items: center;
                margin-bottom: 18px;

                .hand-icon {
                    margin: 8px;
                }
            }

            .form-item-summary {
                text-align: left;
                width: 100%;
                color: #666666;
                font-weight: 400;
                font-size: 18px;
                letter-spacing: 1px;
                margin-bottom: 24px;
            }

            .form-item-merge {
                display: flex;
                justify-content: space-between;
                width: 670px;

                .form-item {
                    width: 324px !important;
                }
            }

            .form-item {
                margin-bottom: 14px;
                width: 670px;
                
                &__title {
                    color: #333333;
                    font-weight: 400;
                    font-size: 16px;
                    margin-bottom: 10px;

                    .isRed {
                        color: #FF5219;
                        padding-right: 4px;
                    }

                    .tips {
                        color: #666666;
                    }
                }

                &__input {
                    background-color: #F7F7FA;
                    border: none;
                    padding: 14px 12px;
                    line-height: 18px;
                    color: #333333;
                    font-weight: 400;
                    font-size: 16px;
                    width: 100%;
                    box-sizing: border-box;
                    border-radius: 4px;
                }

                &__type {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;

                    &-text {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    img {
                        transition: transform 0.25s ease;
                    }

                    img:hover {
                        opacity: .75;
                    }

                    .show-type {
                        transform: rotate(-180deg);
                    }
                }

                &__select {
                    width: 670px;
                    border-radius: 10px;
                    background-color: #FFFFFF;
                    box-shadow: 0px 10px 18px 0px rgba(40, 44, 108, 0.09);
                    margin-top: 14px;
                    padding: 12px;
                    color: #333333;
                    font-weight: 400;
                    font-size: 16px;
                    box-sizing: border-box;
                    position: absolute;
                    transition: opacity 0.5s ease, max-height 0.5s ease;
                    overflow: hidden;
                    
                    &-item {
                        line-height: 22px;
                        padding: 12px;
                        cursor: pointer;
                    }

                    &-active {
                        font-family: PingFangSC-medium;
                        color: #1753A3;
                        font-weight: 500;
                    }

                    &-item:hover {
                        color: #1753A3;
                    }

                }
            }

            .submit-btn {
                width: 670px;
                height: 74px;
                border-radius: 37px;
                background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%),#F8FAFC;
                line-height: 74px;
                text-align: center;
                font-family: PingFangSC-medium;
                color: #FFFFFF;
                font-weight: 500;
                font-size: 24px;
                letter-spacing: 2px;
                cursor: pointer;
            }

            .video-icon {
                position: absolute;
                right: 43px;
                bottom: 24px;
            }
        }
    }
}
/* 响应式布局 */
@media (max-width: 768px) {
    .media {
        &-title {
            font-size: 18px;
            letter-spacing: 0;
            line-height: 24px;  
            margin-bottom: 12px;  
        }

        &-summary {
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 20px;

        }

        .num {
            background-color: #F8FAFC;
            padding: 24px 12px;
            
            &-bg {
                width: 100%;
            }

            &-card {
                width: 100%;
                height: 90px;
                border-radius: 10px;

                .item {

                    .number {
                        font-family: D-DINExp-Bold;
                        color: #333333;
                        font-weight: 700;
                        font-size: 16px;
                        letter-spacing: 1px;
                        line-height: 24px;
                    }

                    .title {
                        font-size: 10px;
                        letter-spacing: 1px;
                        line-height: 12px;
                        margin-top: 4px;
                        height: 25px;
                    }

                    .line {
                        width: 1px;
                        height: 40px;
                        top: 25px;
                    }
                }
            }
        }

        .asset {
            // width: 100%;
            padding: 12px;
            
            &-bg {
                width: 100%;
            }

            &-content {
                gap: 20px;
                margin-top: 12px;
                gap: 10px;
            }

            &-item { 
                width: 48%;
                border-radius: 10px;

                .img {
                    width: 100%;
                    height: 86px;
                    border-radius: 10px 10px 0px 0px;
                }

                .item {
                    margin: 10px 12px;
                    position: relative;

                    &-title {
                        font-size: 12px;
                        letter-spacing: 1px;
                        height: 16px;
                        line-height: 16px;
                        margin-bottom: 5px;
                        max-width: calc(100% - 24px);
                    }

                    &-type {
                        font-size: 10px;
                        letter-spacing: 1px;
                    }

                    &-btn {
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .submit {
            width: 100%;
            padding: 24px 12px;
            margin:auto;
            box-sizing: border-box;

            &-form {
                margin-top: 12px;
                padding: 12px;
                border-radius: 10px;

                .form-item-title {
                    font-size: 16px;
                    letter-spacing: 1px;
                    line-height: 20px;
                    margin-bottom: 4px;

                    .hand-icon {
                        margin: 8px;
                        width: 20px;
                        height: 20px;
                    }
                }

                .form-item-summary {
                    font-size: 10px;
                    letter-spacing: 0;
                    margin-bottom: 12px;
                }

                .form-item-merge {
                    display: block;
                    width: 100%;

                    .form-item {
                        width: 100% !important;
                    }
                }

                .form-item {
                    margin-bottom: 10px;
                    width: 100%;
                    
                    &__title {
                        color: #333333;
                        font-weight: 400;
                        font-size: 14px;
                        margin-bottom: 6px;

                        .isRed {
                            color: #FF5219;
                            padding-right: 4px;
                        }
                    }

                    &__input {
                        padding: 10px 8px;
                        line-height: 16px;
                        color: #333333;
                        font-size: 12px;
                        width: 100%;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }

                    &__select {
                        width: calc(100% - 24px);
                        border-radius: 4px;
                        margin-top: 7px;
                        font-size: 12px;
                        
                        &-item {
                            line-height: 16px;
                            padding: 8px;
                        }

                    }
                }

                .submit-btn {
                    width: 100%;
                    height: 40px;
                    border-radius: 37px;
                    line-height: 40px;
                    text-align: center;
                    margin-top: 10px;
                    font-size: 14px;
                    letter-spacing: 1px;
                }

                .video-icon {
                    position: absolute;
                    right: 23px;
                    bottom: 130px;
                    z-index: 0;
                    width: 80px;
                }
            }
        }
    }
}
</style>
    

